export class StateContext {
  constructor({ controller, InitialInstance, eventType }) {
    this._InitialInstance = InitialInstance;
    this._eventType = eventType;
    this.controller = controller;
    this.transitionTo(new InitialInstance());
  }

  transitionTo(state) {
    this.state = state;
    this.state.setContext(this);
    this.controller.events.notify(this._eventType, state.payload);
  }

  reset() {
    const InitialInstance = this._InitialInstance;
    if (this.state instanceof InitialInstance) return;
    this.transitionTo(new InitialInstance());
  }
}

export class State {
  constructor(payload) {
    this.payload = payload;
  }

  setContext(context) {
    this.context = context;
  }
}
